import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import menuListReducer from './reducers/menuListReducer';
import pageListReducer from './reducers/pageListReducer';
import eventsReducer from './reducers/eventsReducer';
import statesReducer from './reducers/statesReducer';
import lawyersReducer from './reducers/lawyersReducer';
import representativesReducer from './reducers/representativesReducer';
import voteLocationsReducer from './reducers/voteLocationsReducer';
import copiesListReducer from './reducers/copiesListReducer';

const reducer = combineReducers({
  menu: menuListReducer,
  pages: pageListReducer,
  events: eventsReducer,
  states: statesReducer,
  lawyers: lawyersReducer,
  representatives: representativesReducer,
  voteLocations: voteLocationsReducer,
  copies: copiesListReducer,
});

const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));

export default store;
